export const AppsVideoExamplesContent = {
  content_blocks: 205,
  recommendations: 554,
  upsells: 554,
  'fake-click': 406,
};
